var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "airplay_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#airplay_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21V9c0-.55.196-1.02.588-1.412A1.926 1.926 0 018 7h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0124 23h-2a.968.968 0 01-.712-.288A.968.968 0 0121 22c0-.283.096-.52.288-.712A.968.968 0 0122 21h2V9H8v12h2c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0110 23H8c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 016 21zm5.8 4a.68.68 0 01-.55-.238.781.781 0 01-.2-.512.724.724 0 01.225-.525L15.3 19.7c.1-.1.208-.175.325-.225A.942.942 0 0116 19.4c.133 0 .258.025.375.075.117.05.225.125.325.225l4.025 4.025a.724.724 0 01.225.525.781.781 0 01-.2.512.68.68 0 01-.55.238h-8.4z",
    fill: "#fff"
  }))));
}
export default SvgAirplay;